/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { AiOutlineMail } from "react-icons/ai";
import { BiTransfer } from "react-icons/bi";
import {
  BsCurrencyExchange,
  BsDoorOpen,
  BsFileEarmarkPdfFill,
  BsGearWideConnected,
  BsReverseLayoutTextWindowReverse,
  BsWalletFill,
} from "react-icons/bs";
import { FaMoneyBillAlt, FaUserAlt } from "react-icons/fa";
import { FcMoneyTransfer, FcRules, FcWorkflow } from "react-icons/fc";
import { FiAlertTriangle } from "react-icons/fi";
import { GiSandsOfTime } from "react-icons/gi";
import { GrUserAdmin, GrUserWorker } from "react-icons/gr";
import { HiChartBarSquare } from "react-icons/hi2";
import { ImUpload, ImUsers } from "react-icons/im";
import { IoIosCreate } from "react-icons/io";
import {
  MdAccountBalanceWallet,
  MdOutlineAccountBalance,
  MdOutlineHistory,
  MdPayment,
  MdPending,
  MdRequestPage,
  MdSettings,
  MdSupportAgent,
} from "react-icons/md";
import { RiAddCircleLine } from "react-icons/ri";
import { SiKnown } from "react-icons/si";
import { VscVerified } from "react-icons/vsc";
import { NavLink } from "react-router-dom";
import cashSvg from "../../assets/images/svgs/cash.svg";
import document from "../../assets/images/svgs/document.svg";
import peopleSvg from "../../assets/images/svgs/people.svg";
import reportSvg from "../../assets/images/svgs/report.svg";
import transferSvg from "../../assets/images/svgs/transfer.svg";
import walletSvg from "../../assets/images/svgs/wallet.svg";
import {
  menuInitialStatus,
  menuType,
  userTypes,
} from "../../utils/helpers/constants";
import { getBaseUrl } from "../../utils/services/baseUrl";

function DigitalBankingMenu({
  active,
  menu,
  domainBrand,
  profile,
  userModules,
}) {
  const dropDownInitState = menuInitialStatus;
  const [dropDownStatus, updateDropDownStatus] = useState(dropDownInitState);
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  const languageStatus = !(
    typeof dictionary === "undefined" || dictionary === null
  );
  const reboundNav = (event, id) => {
    event.preventDefault();
    expandMenu(id);
  };

  const expandMenu = (idName) => {
    const dropDownData = { ...dropDownInitState, [idName]: true };
    updateDropDownStatus(dropDownData);
  };

  const domainUrl = getBaseUrl();

  useEffect(() => {
    expandMenu(menu);
  }, [menu]);

  return (
    <>
      {/* MANAGER --> used in conjuction with userTypes to render menu items */}
      {/* REPORTS */}
      {/* {profile.userType === userTypes.MANAGER ? (
        <li>
          <NavLink
            exact
            to="/"
            className={menu === menuType.REPORTS ? "active" : ""}
          >
            <img src={reportSvg} alt="arrowRight" /> &nbsp;
            {languageStatus ? dictionary["para_reports"] : "Reports"} &nbsp;
            <i className="fa fa-angle-down horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu ${
              dropDownStatus[menuType.REPORTS]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "reports" ? "active" : ""}>
              <NavLink exact to="/statement" className="slide-item">
                <BiTransfer fontSize={25} color={"#6259CA"} />
                &nbsp;
                
                Account Statement
              </NavLink>
            </li>
          </ul>
        </li>
      ) : (
        ""
      )} */}

      {/* MANAGEMENT */}
      {/* {profile.userType === userTypes.MANAGER && (
        <li>
          <NavLink
            exact
            to="/"
            className={menu === menuType.REPORTS ? "active" : ""}
          >
            <img src={reportSvg} alt="arrowRight" /> &nbsp;
            {languageStatus ? dictionary["para_management"] : "Management"}{" "}
            &nbsp;
            <i className="fa fa-angle-down horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu ${
              dropDownStatus[menuType.MANAGEMENT]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "reports" ? "active" : ""}>
              <NavLink
                exact
                to="/management/partner-agents"
                className="slide-item"
              >
                <FaUserAlt color={"#6259CA"} fontSize={20} fill={"#6259CA"} />
                &nbsp;
                {languageStatus
                  ? dictionary["m_trading_partners"]
                  : "Partners/Agents/Branches"}
              </NavLink>
            </li>

            <li className={active === "reports" ? "active" : ""}>
              <NavLink
                exact
                to="/report/my-transactions"
                className="slide-item"
              >
                <FaUserAlt color={"#6259CA"} fontSize={20} fill={"#6259CA"} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_APPROVEDISAPPROVE_P_36761235"]
                  : "Approve/Disapprove Agents"}
              </NavLink>
            </li>
          </ul>
        </li>
      )} */}

      {/* EMPLOYEE */}
      {/* {profile.userType === userTypes.MANAGER && (
        <li>
          <NavLink
            exact
            to="/"
            className={menu === menuType.REPORTS ? "active" : ""}
          >
            <img src={reportSvg} alt="arrowRight" /> &nbsp;
            {languageStatus
              ? dictionary["WO_EMPLOYEE_-1048133672"]
              : "Employees"}
            &nbsp;
            <i className="fa fa-angle-down horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu sub-menu-top ${
              dropDownStatus[menuType.MANAGEMENT]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "reports" ? "active" : ""}>
              <NavLink
                exact
                to="/report/my-transactions"
                className="slide-item"
              >
                <BiTransfer fontSize={25} color={"#6259CA"} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_APPROVEDISAPPROVE_C_699420565"]
                  : "Approve/Disapprove Cashier Profiles"}
              </NavLink>
            </li>

            <li className={active === "reports" ? "active" : ""}>
              <NavLink
                exact
                to="/report/my-transactions"
                className="slide-item"
              >
                <BiTransfer fontSize={25} color={"#6259CA"} />
                &nbsp;
                {languageStatus
                  ? dictionary["para_pay_center_admins"]
                  : "Administrators"}
              </NavLink>
            </li>
          </ul>
        </li>
      )} */}

      {/* {profile.userType === userTypes.MANAGER && (
        <li>
          <NavLink
            exact
            to="/"
            className={menu === menuType.REPORTS ? "active" : ""}
          >
            <img src={reportSvg} alt="arrowRight" /> &nbsp;
            {languageStatus
              ? dictionary["m_load_data_from_file"]
              : "Import Data From File"}
            &nbsp;
          </NavLink>
        </li>
      )} */}

      {/* COMPLIANCE */}
      {/* {profile.userType === userTypes.MANAGER && (
        <li>
          <NavLink
            onClick={(event) => reboundNav(event, menuType.COMPLIANCE)}
            exact
            to="/compliance"
            className={menu === menuType.COMPLIANCE ? "active" : ""}
          >
            <img src={walletSvg} alt="homeSvg" /> &nbsp;
            {languageStatus ? dictionary["m_compliance"] : "Compliance"} &nbsp;
            <i className="fa fa-angle-down float end horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu ${
              dropDownStatus[menuType.COMPLIANCE]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "customer" ? "active" : ""}>
              <NavLink to="/kyc-rules" className="slide-item">
                <SiKnown color={"#6259CA"} fontSize={24} />
                &nbsp;
                {languageStatus
                  ? dictionary["KYCKNOW_YOUR_CUSTOM_723094592"]
                  : "KYC Rules"}
              </NavLink>
            </li>
            <li>
              <NavLink to="/aml-rules" className="slide-item">
                <FcRules color={"#6259CA"} fontSize={24} />
                &nbsp;
                {languageStatus
                  ? dictionary["m_transaction_rules"]
                  : "AML Rules"}
              </NavLink>
            </li>
            <li>
              <NavLink to="/awaiting-verification" className="slide-item">
                <VscVerified color={"#6259CA"} fontSize={24} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_AWAITING_VERIFICATIO_4608421"]
                  : "Awaiting Verification"}
              </NavLink>
            </li>
            <li>
              <NavLink to="/transaction-alerts" className="slide-item">
                <FiAlertTriangle color={"#6259CA"} fontSize={24} />
                &nbsp;
                {languageStatus
                  ? dictionary["para_transaction_alerts"]
                  : "Transaction Alerts"}
              </NavLink>
            </li>
          </ul>
        </li>
      )} */}

      {/* CRM */}
      {/* {profile.userType === userTypes.MANAGER && (
        <li>
          <NavLink
            onClick={(event) => reboundNav(event, menuType.CRM)}
            exact
            to="/crm"
            className={menu === menuType.CRM ? "active" : ""}
          >
            <img src={walletSvg} alt="homeSvg" /> &nbsp;
            {languageStatus ? dictionary["WO_CR_-560706472"] : "CRM"} &nbsp;
            <i className="fa fa-angle-down float end horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu sub-menu-top ${
              dropDownStatus[menuType.CRM] ? "submenu-dropdown" : "no-dropdown"
            }`}
          >
            <li className={active === "customer" ? "active" : ""}>
              <NavLink to="/customers" className="slide-item">
                <ImUsers color={"#6259CA"} fontSize={25} />
                &nbsp;
                {languageStatus ? dictionary["m_manage_customer"] : "Customers"}
              </NavLink>
            </li>
          </ul>
        </li>
      )} */}

      {/* PRODUCTS */}
      {/* {profile.userType === userTypes.MANAGER && (
        <li>
          <NavLink
            onClick={(event) => reboundNav(event, menuType.COMPLIANCE)}
            exact
            to="/customer-products"
            className={menu === menuType.COMPLIANCE ? "active" : ""}
          >
            <img src={walletSvg} alt="homeSvg" /> &nbsp;
            {languageStatus
              ? dictionary["WO_PRODUCT_-541446518"]
              : "Products"}{" "}
            &nbsp;
            <i className="fa fa-angle-down float end horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu sub-menu-top ${
              dropDownStatus[menuType.COMPLIANCE]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "customer" ? "active" : ""}>
              <NavLink to="/customer-products" className="slide-item">
                <SiKnown color={"#6259CA"} fontSize={24} />
                &nbsp;
                {languageStatus ? dictionary["WO_ACCOUN_93052003"] : "Account"}
              </NavLink>
            </li>
            <li className={active === "customer" ? "active" : ""}>
              <NavLink to="/customer-products" className="slide-item">
                <SiKnown color={"#6259CA"} fontSize={24} />
                &nbsp;
                {languageStatus ? dictionary["WO_LOA_-1193075533"] : "Loan"}
              </NavLink>
            </li>
          </ul>
        </li>
      )} */}

      {/* TREASURY */}
      {/* {profile.userType === userTypes.MANAGER && (
        <li>
          <NavLink
            onClick={(event) => reboundNav(event, menuType.COMPLIANCE)}
            exact
            to="/compliance"
            className={menu === menuType.TREASURY ? "active" : ""}
          >
            <img src={walletSvg} alt="homeSvg" /> &nbsp;
           
            Treasury &nbsp;
            <i className="fa fa-angle-down float end horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu sub-menu-top ${
              dropDownStatus[menuType.COMPLIANCE]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "cashflow" ? "active" : ""}>
              <NavLink to="/treasury/cashflow" className="slide-item">
                <SiKnown color={"#6259CA"} fontSize={24} />
                &nbsp;
                {dictionary["WO_CASHFLO_128197323"] !== undefined
                  ? dictionary["WO_CASHFLO_128197323"]
                  : "Cashflow"}
              </NavLink>
            </li>
          </ul>
        </li>
      )} */}

      {/* CROSS BORDER */}
      {/* {profile.userType === userTypes.MANAGER && (
        <li>
          <NavLink
            onClick={(event) => reboundNav(event, menuType.CROSSBORDER)}
            exact
            to="/security"
            className={menu === menuType.CROSSBORDER ? "active" : ""}
          >
            <MdSettings color={"#6259CA"} fontSize={23} /> &nbsp; Cross Border
            &nbsp;
            <i className="fa fa-angle-down float end horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu sub-menu-top ${
              dropDownStatus[menuType.CROSSBORDER]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "customer" ? "active" : ""}>
              <NavLink to="" className="slide-item">
                <MdSettings color={"#6259CA"} fontSize={25} />
                &nbsp; Setup
              </NavLink>
            </li>
            <li>
              <NavLink to="" className="slide-item">
                <MdSettings color={"#6259CA"} fontSize={20} />
                &nbsp; Tax
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/settings/bank-account-settings"
                className="slide-item"
                style={{ fontSize: "15px" }}
              >
                <MdSettings color={"#6259CA"} fontSize={20} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_BANK_FIELD_951387132"]
                  : "Bank Fields"}
              </NavLink>
            </li>
            <li>
              <NavLink to="" className="slide-item">
                <MdSettings color={"#6259CA"} fontSize={20} />
                &nbsp; Cross-Border Transfer fee
              </NavLink>
            </li>
          </ul>
        </li>
      )} */}

      {/* {profile.userType === userTypes.MANAGER && (
        <li>
          <NavLink
            onClick={(event) => reboundNav(event, menuType.SETTINGS)}
            exact
            to="/settings"
            className={menu === menuType.SETTINGS ? "active" : ""}
          >
            <MdSettings color={"#6259CA"} fontSize={23} /> &nbsp; Settings
            &nbsp;
            
            <i className="fa fa-angle-down float end horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu sub-menu-top ${
              dropDownStatus[menuType.SETTINGS]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "workflow" ? "active" : ""}>
              <NavLink to="/settings/workflow" className="slide-item">
                <FcWorkflow color={"#6259CA"} fontSize={20} fill={"#6259CA"} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_WORKFLO_-434837466"]
                  : "Workflow"}
              </NavLink>
            </li>

            <li className={active === "remittance-settings" ? "active" : ""}>
              <NavLink
                to="/settings/remittance-fee-settings"
                className="slide-item"
              >
                <BsGearWideConnected
                  color={"#6259CA"}
                  fontSize={20}
                  fill={"#6259CA"}
                />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_REMITTANCE_SETTING_-1350168954"]
                  : "Remittance Settings"}
              </NavLink>
            </li>

            <li className={active === "brand" ? "active" : ""}>
              <NavLink to="/settings/brand-settings" className="slide-item">
                <BsGearWideConnected
                  color={"#6259CA"}
                  fontSize={20}
                  fill={"#6259CA"}
                />
                &nbsp;
                {languageStatus
                  ? dictionary["m_visual_settings"]
                  : "Brand Settings"}
              </NavLink>
            </li>

            <li className={active === "email" ? "active" : ""}>
              <NavLink to="/settings/email-settings" className="slide-item">
                <AiOutlineMail
                  color={"#6259CA"}
                  fontSize={20}
                  fill={"#6259CA"}
                />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_EMAIL_SETTING_2052406034"]
                  : "Email Settings"}
              </NavLink>
            </li>
          </ul>
        </li>
      )} */}

      {/* FEE */}
      {/* {profile.userType === userTypes.MANAGER && (
        <li>
          <NavLink
            onClick={(event) => reboundNav(event, menuType.SECURITY)}
            exact
            to=""
            className={menu === menuType.SECURITY ? "active" : ""}
          >
            <MdSettings color={"#6259CA"} fontSize={23} /> &nbsp;
            {languageStatus ? dictionary["m_set_remittance_commission"] : "Fee"}
            &nbsp;
            <i className="fa fa-angle-down float end horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu sub-menu-top ${
              dropDownStatus[menuType.SECURITY]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "customer" ? "active" : ""}>
              <NavLink to="" className="slide-item">
                <MdSettings color={"#6259CA"} fontSize={25} />
                &nbsp;
                {languageStatus
                  ? dictionary["para_payment_method"]
                  : "Payment Method"}
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/settings/rates"
                className="slide-item"
                style={{ fontSize: "15px" }}
              >
                <MdSettings color={"#6259CA"} fontSize={20} />
                &nbsp;
                {languageStatus
                  ? dictionary["m_bureau_exchange_rates"]
                  : "Exchange Rates"}
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/settings/interest-rate"
                className="slide-item"
                style={{ fontSize: "15px" }}
              >
                <MdSettings color={"#6259CA"} fontSize={20} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_INTEREST_RAT_1193574154"]
                  : "Account Maintenance Fee"}
              </NavLink>
            </li>
            <li>
              <NavLink
                onClick={(event) => reboundNav(event, menuType.TRANSFER)}
                exact
                to="/transfer"
                className={menu === menuType.TRANSFER ? "active" : ""}
              >
                <img src={transferSvg} alt="arrowRight" /> &nbsp;
                {languageStatus
                  ? dictionary["m_wallet_fund_transfer"]
                  : "Transfers"}{" "}
              </NavLink>
            </li>
          </ul>
        </li>
      )} */}

      {/* SECURITY */}
      {/* {profile.userType === userTypes.MANAGER && (
        <li>
          <NavLink
            onClick={(event) => reboundNav(event, menuType.SECURITY)}
            exact
            to="/security"
            className={menu === menuType.SECURITY ? "active" : ""}
          >
            <MdSettings color={"#6259CA"} fontSize={23} /> &nbsp; Security
            &nbsp;
            
            <i className="fa fa-angle-down float end horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu sub-menu-top ${
              dropDownStatus[menuType.SECURITY]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "customer" ? "active" : ""}>
              <NavLink to="/customers" className="slide-item">
                <MdSettings color={"#6259CA"} fontSize={25} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_IP_ADDRESS_RESTRICTI_-421114094"]
                  : "IP Whitelisting"}
              </NavLink>
            </li>
            <li>
              <NavLink to="/" className="slide-item">
                <MdSettings color={"#6259CA"} fontSize={20} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_TWO_FACTOR_AUTHENTIC_-1180686726"]
                  : "Two Factor Authentication"}
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/account-creation"
                className="slide-item"
                style={{ fontSize: "15px" }}
              >
                <MdSettings color={"#6259CA"} fontSize={20} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_ENABLE_STRONG_CUSTOM_-1835724157"]
                  : "Strong Customer Authentication"}
              </NavLink>
            </li>
            <li>
              <NavLink to="/account-creation" className="slide-item">
                <MdSettings color={"#6259CA"} fontSize={20} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_PASSWORD_POLIC_-261182106"]
                  : "Password Policy"}
              </NavLink>
            </li>
            <li>
              <NavLink to="/account-creation" className="slide-item">
                <MdSettings color={"#6259CA"} fontSize={20} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_ENABLE_TRANSACTION_P_1460895606"]
                  : "Enable Transaction Pin"}
              </NavLink>
            </li>
          </ul>
        </li>
      )} */}

      {/* {profile.userType === userTypes.MANAGER && (
        <li>
          <NavLink
            onClick={(event) => reboundNav(event, menuType.PLUGIN_API)}
            exact
            to="/settings"
            className={menu === menuType.PLUGIN_API ? "active" : ""}
          >
            <MdSettings color={"#6259CA"} fontSize={23} /> &nbsp;{" "}
            {dictionary ? dictionary["WO_PLUGINSAP_-161147171"] : "Plugins/API"}
            &nbsp;
            
            <i className="fa fa-angle-down float end horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu sub-menu-top2 ${
              dropDownStatus[menuType.PLUGIN_API]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "customer" ? "active" : ""}>
              <NavLink to="/customers" className="slide-item">
                <MdSettings color={"#6259CA"} fontSize={25} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_ADD_NEW_PLUGI_1498103904"]
                  : "Add Pay-out API"}
              </NavLink>
            </li>
          </ul>
        </li>
      )} */}

      {/* CASHIER --> used in conjuction with userTypes to render menu items */}
      {/* REPORTS */}
      {/* {profile.userType === userTypes.CASHIER ? (
        <li>
          <NavLink
            exact
            to="/"
            className={menu === menuType.REPORTS ? "active" : ""}
          >
            <img src={reportSvg} alt="arrowRight" /> &nbsp;
            {languageStatus ? dictionary["para_reports"] : "Reports"} &nbsp;
            <i className="fa fa-angle-down horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu ${
              dropDownStatus[menuType.REPORTS]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "reports" ? "active" : ""}>
              <NavLink exact to="/statement" className="slide-item">
                <BsFileEarmarkPdfFill fontSize={24} color={"#6259CA"} />
                &nbsp;
                {languageStatus
                  ? dictionary["l_wallet_transaction_history"]
                  : "Account Statement"}
              </NavLink>
            </li>
          </ul>
        </li>
      ) : (
        ""
      )} */}

      {/* {profile.userType === userTypes.CASHIER ? (
        <li>
          <NavLink
            exact
            to="/"
            className={menu === menuType.TRANSACTIONS ? "active" : ""}
          >
            <img src={reportSvg} alt="arrowRight" /> &nbsp;
            {languageStatus
              ? dictionary["para_transaction"]
              : "Transaction"}{" "}
            &nbsp;
            <i className="fa fa-angle-down horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu ${
              dropDownStatus[menuType.REPORTS]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "transactions" ? "active" : ""}>
              <NavLink exact to="/fund-wallet" className="slide-item">
                <RiAddCircleLine fontSize={25} color={"#6259CA"} />
                &nbsp; Fund Customer Account
              </NavLink>
            </li>

            {domainBrand.serviceControl.transfer && (
              <li className={active === "transfers" ? "active" : ""}>
                <NavLink exact to="/transfer" className="slide-item">
                  <FcMoneyTransfer fontSize={25} color={"#6259CA"} />
                  &nbsp;
                  {languageStatus
                    ? dictionary["WO_TRANSFER_FUND_-1694451190"]
                    : "Transfer Funds"}
                </NavLink>
              </li>
            )}

            {domainBrand.serviceControl.billPayment ? (
              <li className={active === "billPayment" ? "active" : ""}>
                <NavLink exact to="/bill-payment" className="slide-item">
                  <MdPayment fontSize={24} color={"#6259CA"} />
                  &nbsp;
                  {languageStatus
                    ? dictionary["WO_BILL_PAYMEN_-1233806888"]
                    : "Bill Payments"}
                </NavLink>
              </li>
            ) : (
              ""
            )}
          </ul>
        </li>
      ) : (
        ""
      )} */}

      {/* CUSTOMER --> used in conjuction with userTypes to render menu items*/}

      {/* ACCOUNTS */}
      {domainBrand.serviceControl.wallet &&
      profile.userType === userTypes.CUSTOMER ? (
        <li>
          <NavLink
            onClick={(event) => reboundNav(event, menuType.ACCOUNTS)}
            exact
            to="/balances"
            className={menu === menuType.ACCOUNTS ? "active" : ""}
          >
            <img src={walletSvg} alt="homeSvg" /> &nbsp;
            {languageStatus
              ? dictionary["WO_ACCOUNT_1211395312"]
              : "Accounts"}{" "}
            &nbsp;
            <i className="fa fa-angle-down float end horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu ${
              dropDownStatus[menuType.ACCOUNTS]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "balances" ? "active" : ""}>
              <NavLink to="/balances" className="slide-item">
                <MdAccountBalanceWallet fontSize={26} color={"#6259CA"} />{" "}
                &nbsp;
                {languageStatus
                  ? dictionary["WO_ACCOUNT_BALANCE_960871353"]
                  : "Account Balances"}
              </NavLink>
            </li>
            <li className={active === "request-account" ? "active" : ""}>
              <NavLink to="/request-account" className="slide-item">
                <MdRequestPage color={"#6259CA"} fontSize={25} /> &nbsp;
                {languageStatus
                  ? dictionary["WO_REQUEST_BANK_ACCOUN_1842427382"]
                  : "Request Account"}
              </NavLink>
            </li>
            {profile.userType === userTypes.CUSTOMER ? (
              <li>
                <NavLink to="/statement" className="slide-item">
                  <BsFileEarmarkPdfFill fontSize={24} color={"#6259CA"} />{" "}
                  &nbsp;
                  {languageStatus
                    ? dictionary["l_wallet_transaction_history"]
                    : "Account Statements"}
                </NavLink>
              </li>
            ) : (
              ""
            )}
            <li className={active === "fund-wallet" ? "active" : ""}>
              <NavLink to="/fund-wallet" className="slide-item">
                <FaMoneyBillAlt fontSize={25} color={"#6259CA"} /> &nbsp;
                {languageStatus ? dictionary["l_fund_wallet"] : "Add Money"}
              </NavLink>
            </li>
          </ul>
        </li>
      ) : (
        ""
      )}

      {/* {profile.userType === userTypes.CUSTOMER && (
        <li>
          <NavLink
            exact
            to="/beneficiaries"
            className={
              menu === menuType.BENEFICIARY ? "sub-icon active" : "sub-icon"
            }
          >
            <img src={peopleSvg} alt="arrowRight" /> &nbsp;
            {languageStatus
              ? dictionary["WO_BENEFICIARIE_-1845397122"]
              : "Beneficiaries"}
          </NavLink>
        </li>
      )} */}

      {/* PRODUCTS */}
      {profile.userType === userTypes.CUSTOMER && (
        <li>
          <NavLink
            exact
            to="/customer-products"
            className={
              menu === menuType.CUSTOMERPRODUCTS
                ? "sub-icon active"
                : "sub-icon"
            }
          >
            <BsWalletFill color={"#6259CA"} fontSize={23} /> &nbsp;
            {languageStatus ? dictionary["WO_PRODUCT_-541446518"] : "Products"}
          </NavLink>
        </li>
      )}

      {/* REPORTS --> REMOVED */}
      {/* {profile.userType === userTypes.CUSTOMER ? (
        <li>
          <NavLink
            exact
            to="/"
            className={menu === menuType.REPORTS ? "active" : ""}
          >
            <img src={reportSvg} alt="arrowRight" /> &nbsp;
            {languageStatus ? dictionary["para_reports"] : "Reports"} &nbsp;
            <i className="fa fa-angle-down horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu ${
              dropDownStatus[menuType.REPORTS]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "reports" ? "active" : ""}>
              <NavLink exact to="/statement" className="slide-item">
                <BsFileEarmarkPdfFill fontSize={24} color={"#6259CA"} />
                &nbsp; Ledger Activities
              </NavLink>
            </li>
          </ul>
        </li>
      ) : (
        ""
      )} */}

      {/* TRANSACTIONS */}
      {/* {profile.userType === userTypes.CUSTOMER ? (
        <li>
          <NavLink
            exact
            to="/"
            className={menu === menuType.TRANSACTIONS ? "active" : ""}
          >
            <HiChartBarSquare color={"#6259CA"} fontSize={23} /> &nbsp;
            {languageStatus
              ? dictionary["para_transactions"]
              : "Transactions"}{" "}
            &nbsp;
            <i className="fa fa-angle-down horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu ${
              dropDownStatus[menuType.REPORTS]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "transactions" ? "active" : ""}>
              <NavLink exact to="/fund-wallet" className="slide-item">
                <RiAddCircleLine fontSize={25} color={"#6259CA"} />
                &nbsp;
                {languageStatus ? dictionary["l_fund_wallet"] : "Add Money"}
              </NavLink>
            </li>

            {domainBrand.serviceControl.transfer && (
              <li className={active === "transactions" ? "active" : ""}>
                <NavLink exact to="/transfer" className="slide-item">
                  <FcMoneyTransfer fontSize={25} color={"#6259CA"} />
                  &nbsp;
                  {languageStatus
                    ? dictionary["WO_TRANSFER_FUND_-1694451190"]
                    : "Transfer Funds"}
                </NavLink>
              </li>
            )}
            {domainBrand.serviceControl.billPayment ? (
                  <li className={active === "billPayment" ? "active" : ""}>
                    <NavLink exact to="/bill-payment" className="slide-item">
                      <MdPayment fontSize={24} color={"#6259CA"} />
                      &nbsp;
                      {languageStatus
                        ? dictionary["WO_BILL_PAYMEN_-1233806888"]
                        : "Bill Payments"}
                    </NavLink>
                  </li>
                ) : (
                  ""
                )}
            
              <li className={active === "billPayment" ? "active" : ""}>
                <NavLink exact to="/bill-payment" className="slide-item">
                  <MdPayment fontSize={24} color={"#6259CA"} />
                  &nbsp;
                  {languageStatus
                    ? dictionary["WO_BILL_PAYMEN_-1233806888"]
                    : "Bill Payments"}
                </NavLink>
              </li>
            

            <li>
              <NavLink
                exact
                to="/customer-products"
                className={
                  menu === menuType.CUSTOMERPRODUCTS
                    ? "sub-icon active"
                    : "sub-icon"
                }
              >
                <BsWalletFill color={"#6259CA"} fontSize={23} /> &nbsp;
                {languageStatus
                  ? dictionary["WO_PRODUCT_-541446518"]
                  : "Products"}
              </NavLink>
            </li>
          </ul>
        </li>
      ) : (
        ""
      )} */}

      {/* BRANCH_ADMIN --> used in conjuction with userTypes to render menu items*/}
      {/* {profile.userType === userTypes.BRANCH_ADMIN ||
      profile.userType === userTypes.AGENTS ? (
        <li>
          <NavLink
            exact
            to="/"
            className={menu === menuType.REPORTS ? "active" : ""}
          >
            <img src={reportSvg} alt="arrowRight" /> &nbsp;
            {languageStatus ? dictionary["para_reports"] : "Reports"} &nbsp;
            <i className="fa fa-angle-down horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu ${
              dropDownStatus[menuType.REPORTS]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "reports" ? "active" : ""}>
              <NavLink
                exact
                to="/report/my-transactions"
                className="slide-item"
              >
                <BiTransfer fontSize={25} color={"#6259CA"} />
                &nbsp; Branch Ledger Activities
              </NavLink>
            </li>
          </ul>
        </li>
      ) : (
        ""
      )} */}

      {/* {profile.userType === userTypes.BRANCH_ADMIN ||
      profile.userType === userTypes.AGENTS ? (
        <li>
          <NavLink
            exact
            to="/"
            className={menu === menuType.REPORTS ? "active" : ""}
          >
            <img src={reportSvg} alt="arrowRight" /> &nbsp;
            {languageStatus ? dictionary["para_management"] : "Management"}{" "}
            &nbsp;
            <i className="fa fa-angle-down horizontal-icon" />
          </NavLink>
          <ul
            className={`sub-menu ${
              dropDownStatus[menuType.MANAGEMENT]
                ? "submenu-dropdown"
                : "no-dropdown"
            }`}
          >
            <li className={active === "reports" ? "active" : ""}>
              <NavLink
                exact
                to="/report/my-transactions"
                className="slide-item"
              >
                <BiTransfer fontSize={25} color={"#6259CA"} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_EMPLOYEE_-1048133672"]
                  : "Employees"}
              </NavLink>
            </li>

            <li className={active === "reports" ? "active" : ""}>
              <NavLink
                exact
                to="/report/my-transactions"
                className="slide-item"
              >
                <BiTransfer fontSize={25} color={"#6259CA"} />
                &nbsp;
                {languageStatus
                  ? dictionary["WO_APPROVEDISAPPROVE_C_699420565"]
                  : "Approve/Disapprove Cashier Profiles"}
              </NavLink>
            </li>

            <li className={active === "reports" ? "active" : ""}>
              <NavLink
                exact
                to="/report/my-transactions"
                className="slide-item"
              >
                <BiTransfer fontSize={25} color={"#6259CA"} />
                &nbsp;
                {languageStatus
                  ? dictionary["m_load_data_from_file"]
                  : "Import Data From File"}
              </NavLink>
            </li>
          </ul>
        </li>
      ) : (
        ""
      )} */}
    </>
  );
}

export default DigitalBankingMenu;
